<template>
  <div>
    <wc-section-title title='Notices'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'notices-base',
  computed: {
    menu () {
      return [
        {
          title: 'Notices Dashboard',
          icon: this.$store.state.icons.modules.notices.icon,
          route: { name: 'NoticesDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Notices Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>